const LOCAL_STORAGE_NAME = "tnmarket_wishlist";

export function getWishlist() {
  if (typeof window === "undefined") return [];
  const wishlist = localStorage.getItem(LOCAL_STORAGE_NAME) ?? null;
  return wishlist ? JSON.parse(wishlist) : [];
}

export function addToWishlist(product) {
  if (typeof window === "undefined") return;
  const wishlist = getWishlist();
  const existingProduct = wishlist.find(
    (item) => item.id_product === product.id_product,
  );
  if (!existingProduct) {
    wishlist.push(product);
    localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(wishlist));
    window.dispatchEvent(new Event("wishlistUpdate"));
  }
}

export function removeFromWishlist(productId) {
  if (typeof window === "undefined") return;
  const wishlist = getWishlist();
  const updatedWishlist = wishlist.filter(
    (item) => item.id_product !== productId,
  );
  localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(updatedWishlist));
  window.dispatchEvent(new Event("wishlistUpdate"));
}

export function clearWishlist() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(LOCAL_STORAGE_NAME);
  window.dispatchEvent(new Event("wishlistUpdate"));
}

export function isInWishlist(productId) {
  const wishlist = getWishlist();
  return wishlist.some((item) => item.id_product === productId);
}
